import { LabelStyled } from "components/form/inputs/inputs.styled";
import { SettingsSelect } from "components/form/select/select.styled";
import { CustomIcon } from "components/icon/customIcon.component";
import { H4, Text } from "components/Typography/text.styled";
import { Color } from "config/colors";
import { FontFamily, FontSize } from "config/font";
import React, { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useRouteMatch } from "react-router";

import i18n from "services/translation/i18n";
import { TermsAndPrivacy } from "../companySubscription/termsAndPrivacy.component";
import {
  SettingsCategoryContainer,
  SettingsDesktopLayout,
  SettingsListStyled,
  SettingsMenuStyled,
  SettingsPageContainer,
  SideBarStyled,
  TermsContainer,
} from "./companySettingsDesktopView.styled";
import { useCompanyStore } from "web-apps/company/stores/companyStore/companyStore";

type Props = {
  setPage: React.Dispatch<React.SetStateAction<number>>;
  children: JSX.Element;
};

export const CompanySettingsDesktopView: React.FC<Props> = ({
  setPage,
  children,
}) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();
  const history = useHistory();
const [companyState, _companyActions] = useCompanyStore();  
const [customersEnabled, setCustomersEnabled] = useState(false);

  useEffect(() => {
    let customersEnabledSetting = companyState.companySettings.find(setting => setting.key == 'CustomersEnabled');
    let customersIsEnabled = customersEnabledSetting && customersEnabledSetting.value == 'true';
    setCustomersEnabled(!!customersIsEnabled);
  }, [companyState.companySettings])

  const haveOBModule = useMemo(() => {
    return (
      companyState.companySettings?.find(
        (s: any) => s.key === "CompanyShowInconvenientModule"
      )?.value == "true"
    );
  }, [companyState.companySettings]);

  const haveTipModule = useMemo(() => {
    return (
      companyState.companySettings?.find(
        (s: any) => s.key === "CompanyShowTipModule"
      )?.value == "true"
    );
  }, [companyState.companySettings]);
  return (
    <SettingsDesktopLayout>
      <SideBarStyled>
        <SettingsMenuStyled>
          <H4 fontFamily={FontFamily.LeagueSpartanBold}>
            {t("General.Settings")}
          </H4>
          <SettingsListStyled>
            <SettingsCategoryContainer>
              <LabelStyled>{t("ProfileCompany.Company")}</LabelStyled>
              <SettingsSelect
                onClick={() => {
                  setPage(1);
                  history.push(`${path}?page=profile`);
                }}
              >
                <CustomIcon
                  name="person"
                  size="48px"
                  color={Color.BurntSienna}
                  padding="10px"
                />
                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("ProfileCompany.Profile")}
                </Text>
              </SettingsSelect>
              <SettingsSelect
                onClick={() => {
                  setPage(1);
                  history.push(`${path}?page=details`);
                }}
              >
                <CustomIcon
                  name="document"
                  size="48px"
                  color={Color.BurntSienna}
                  padding="10px"
                />

                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("ProfileCompany.Details")}
                </Text>
              </SettingsSelect>
              <SettingsSelect
                onClick={() => {
                  setPage(1);
                  history.push(`${path}?page=users`);
                }}
              >
                <CustomIcon
                  name="person"
                  size="48px"
                  color={Color.BurntSienna}
                  padding="10px"
                />

                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("CompanyUsers.CompanyUsers")}
                </Text>
              </SettingsSelect>
              {customersEnabled && 
                <SettingsSelect
                  onClick={() => {
                    setPage(1);
                    history.push(`${path}?page=Customers`);
                  }}
                >
                  <CustomIcon
                    name="company"
                    size="48px"
                    color={Color.BurntSienna}
                    padding="10px"
                  />

                  <Text
                    fontSize={FontSize.H4}
                    fontFamily={FontFamily.MontserratSemiBold}
                  >
                    {t("ProfileCompany.Customers")}
                  </Text>
                </SettingsSelect>
              }
              {haveOBModule && (
                <SettingsSelect
                  onClick={() => {
                    setPage(1);
                    history.push(`${path}?page=Ob`);
                  }}
                >
                  <CustomIcon
                    name="clock"
                    size="48px"
                    color={Color.BurntSienna}
                    padding="10px"
                  />

                  <Text
                    fontSize={FontSize.H4}
                    fontFamily={FontFamily.MontserratSemiBold}
                  >
                    {t("ProfileCompany.OB")}
                  </Text>
                </SettingsSelect>
              )}
              <SettingsSelect
                onClick={() => {
                  setPage(1);
                  history.push(`${path}?page=Subscription`);
                }}
              >
                <CustomIcon
                  name="wallet"
                  size="48px"
                  color={Color.BurntSienna}
                  padding="10px"
                />

                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("ProfileCompany.Subscription")}
                </Text>
              </SettingsSelect>
              {haveTipModule && (
                <SettingsSelect
                  onClick={() => {
                    setPage(1);
                    history.push(`${path}?page=Tip`);
                  }}
                >
                  <CustomIcon
                    name="cashier"
                    size="48px"
                    color={Color.BurntSienna}
                    padding="10px"
                  />
                  <Text
                    fontSize={FontSize.H4}
                    fontFamily={FontFamily.MontserratSemiBold}
                  >
                    {t("CompanyTip.Tip")}
                  </Text>
                </SettingsSelect>
              )}
              <SettingsSelect
                onClick={() => {
                  setPage(1);
                  history.push(`${path}?page=System`);
                }}
              >
                <CustomIcon
                  name="settings"
                  size="48px"
                  color={Color.BurntSienna}
                  padding="10px"
                />

                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("System.System")}
                </Text>
              </SettingsSelect>
            </SettingsCategoryContainer>
            <SettingsCategoryContainer>
              <LabelStyled>{t("General.Simflexity")}</LabelStyled>
              <SettingsSelect
                onClick={() => {
                  const lang = i18n.language;
                  window.open(`https://www.simflexity.com/kontakt`);
                }}
              >
                <CustomIcon
                  name="mail"
                  size="48px"
                  padding="10px"
                  color={Color.BurntSienna}
                />
                <Text
                  fontSize={FontSize.H4}
                  fontFamily={FontFamily.MontserratSemiBold}
                >
                  {t("General.ContactSupport")}
                </Text>
              </SettingsSelect>
            </SettingsCategoryContainer>
          </SettingsListStyled>
        </SettingsMenuStyled>
        <TermsContainer>
          <TermsAndPrivacy />
        </TermsContainer>
      </SideBarStyled>
      <SettingsPageContainer>{children}</SettingsPageContainer>
    </SettingsDesktopLayout>
  );
};
